import { lazy } from "react";
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedLayout";
import PublicLayout from "../components/layouts/PublicLayout";
import PrivateLayout from "../components/layouts/PrivateLayout";
import ForgotPasswordForm from "../components/login/ForgotPassword";
import SharedChatView from "../pages/shareChatView";
import CollaborationChat from "../pages/CollaborationChat";
import Profile from "../pages/Profile";
import VerifyEmail from "../components/login/verifyEmail";
import PanelLayout from "../components/layouts/PanelLayout";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import DataDeletionInstructions from "../pages/DataDeletionInstructions";
import Blog from "../pages/Blog";
import Upgrade from "../pages/upgradePage";
import UserDetails from "../pages/panels/UserDetails";
import UserChatHistory from "../pages/panels/UserChatHistory";
import TicketDetailsPage from "../pages/panels/TicketDetailsPage";
import FeedbackDetails from "../pages/panels/FeedbackDetailsPage";
import PreferencesPage from "../components/layouts/Preference";
import TermsConditions from "../pages/Terms&Conditions";
// import LinkedInCallback from "../components/auth/LinkedInCallback";
// import FeedbackManagement from './components/Feedback_Management';
const Home = lazy(() => new Promise((resolve) => {
      setTimeout(() => {
        resolve(import("../pages/Home"));
      },0);
    }));

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Login = lazy(() => import("../pages/LoginPage"));
const SignUp = lazy(() => import("../pages/RegisterPage"));
const NotFound = lazy(() => import("../pages/NotFound"));
const GuestChatPage = lazy(() => import("../pages/GuestChatPage"));



const routes = createBrowserRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <Home /> },
      // { path: "home", element: <Home/> },
      { path: "login", element: <Login /> },
      { path: "forgot-password", element: <ForgotPasswordForm /> },
      { path: "verify-email", element: <VerifyEmail /> },
      { path: "signup", element: <SignUp /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/terms-conditions", element: <TermsConditions /> },
      { path: "/blog", element: <Blog /> },
      { path: "/data-deletion-instructions", element: <DataDeletionInstructions /> },
      { path: "/share/:token", element: <SharedChatView /> },
      { path: "/collaborate/:token", element: <CollaborationChat /> },
      { path: "/chat", element: <GuestChatPage /> },
      { path: "/preferences", element: <PreferencesPage /> }
    ],
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <PrivateLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: "user/:userId", element: <UserChatHistory /> },
      { path: "user/:userId/details", element: <UserDetails /> }
    ],
  },
  {
    path: "/ticket/:ticketId",
    element: (
      <ProtectedRoute>
        <PrivateLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <TicketDetailsPage /> }],
  },
  {
    path: "/feedback/:id",
    element: (
      <ProtectedRoute>
        <PrivateLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <FeedbackDetails /> }],
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <PrivateLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: < Profile /> }],
  },
  {
    path: "/upgrade",
    element: (
      <ProtectedRoute>
        <PrivateLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <Upgrade /> }],
  },
  {
    path: "/settings/:panel/*",
    element: (
      <ProtectedRoute>
        <PanelLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "feedback_management", element: lazy(() => import("../pages/panels/FeedbackPage")) }
    ]
    // children: generatePanelRoutes(user.permissions),
  },
  {
    path: "/404",
    element: <NotFound />, // You can create this component
  },

  { path: "*", element: <NotFound /> },
]);

export default routes;
